import { useAtom } from "jotai";
import { ConversationHeader } from "../../../types";
import MessagingConversationHeader from "./MessagingConversations/MessagingConversationHeader";
import { serviceSync } from "../../../services/sync.service";
export type MessagingConversationsProps = {
}

export default function MessagingConversations({ }: MessagingConversationsProps) {
    const [conversations] = useAtom(serviceSync.atomConversations);
    const [selectedConversation] = useAtom(serviceSync.atomSelectedConversation);
    const [visibleConversationAndMessageMap] = useAtom(serviceSync.atomVisibleConversationAndMessageMap);

    return (
        <div className={`flex flex-col w-full`}>
            {conversations.filter(({ id }) => !!visibleConversationAndMessageMap.conversations[id]).map((header) => (
                <MessagingConversationHeader
                    key={header.id}
                    header={header}
                    selected={header.id === selectedConversation}
                    onClick={() => {
                        serviceSync.selectConversation(header.id);
                    }}
                />
            ))}
        </div>
    );
}